import React, { useCallback, useMemo } from 'react';
import { Tooltip } from '@mui/material';
import { useTreeData } from 'utils/hooks/useTreeData';
import BaseKeyNumberGrid from '../Components/BaseKeyNumberGrid';
import ExportToolbar from '../../Datagrid/ExportToolbar';
import VariationBadge from '../../Component/VariationBadge';

const COPRODUITS_ROW_ID = 'Tonnage Co-produits (t)';

const DataGridKeyNumber = ({ rows, columns }) => {
  const renderCell = useCallback((params, colIndex, flatRow) => {
    if (!flatRow) return params.value;
    const dataIndex = colIndex - 1;
    const dataItem = flatRow.originalData.data?.[dataIndex];
    const variation = dataItem?.variation;
    const invertVariation = flatRow.originalData.invertVariation || false;
    const hasVariation = dataIndex > 0 && variation != null;
    if (!hasVariation) return <span>{params.value}</span>;
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1.2,
          height: '100%',
        }}
      >
        <span>{params.value}</span>
        <Tooltip title="Évolution par rapport à la campagne précédente" placement="top" arrow>
          <span>
            <VariationBadge value={variation} inverted={invertVariation} />
          </span>
        </Tooltip>
      </div>
    );
  }, []);

  const { processedColumns, processedRows } = useTreeData(rows, columns, {
    renderCell,
  });

  const getCellClassName = useCallback(
    (params) => {
      if (
        typeof params.id === 'string' &&
        params.id.includes('Qté MS moyenne apportée par campagne')
      ) {
        const row = rows?.find((r) => r.id.includes('Qté MS moyenne apportée par campagne'));
        if (row) {
          const match = row.data.find((d) => params.value !== '-' && params.value === d.value);
          return match ? match.color : '';
        }
      }
      return '';
    },
    [rows],
  );
  const hasCoproduits = rows?.some((r) => r.id === COPRODUITS_ROW_ID && r.children?.length > 0);

  const isGroupExpandedByDefault = useMemo(
    () => (hasCoproduits ? (node) => node.groupingKey === COPRODUITS_ROW_ID : undefined),
    [hasCoproduits],
  );

  return (
    <BaseKeyNumberGrid
      rows={processedRows}
      columns={processedColumns}
      getCellClassName={getCellClassName}
      customToolbar={<ExportToolbar />}
      isGroupExpandedByDefault={isGroupExpandedByDefault}
    />
  );
};

export default DataGridKeyNumber;
